import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../atoms/Icon';
import { getPaymentOptionsLabel, getPayeverChosen } from '../../../utils';


/**
 * A simple PaymentDisplayOption.
 */

class PaymentDisplayOption extends React.Component {
		

    render () {
    	var payeverSubline = '';
    	const { label, subline } = getPaymentOptionsLabel(this.props.choice.group, this.props.choice.data[0]);
    	if(this.props.payeverdata) {
    		payeverSubline = getPayeverChosen(this.props.payeverdata);
    	}
        return (
          <div className="options">
	          <div className="paymentdisplayoption active selected">
	            <div className="toggleselect"><Icon filename="selected" /></div>
	            <div className="inner">
	            	<div className="desc">
		            	<h4 style={{color:"black"}}>
		              		{label}
		              	</h4>
		              	{subline!=='' || payeverSubline!=='' ?
		              	<div className="subline" style={{color:"black"}}>
		              		{payeverSubline!==''?payeverSubline:subline}
		              	</div>
		              	:null}
	            	</div>
	            </div>
          	</div>
          </div>
        );
    }

}

PaymentDisplayOption.propTypes = {
	/** Button label */
	choice: PropTypes.object.isRequired
}


export default PaymentDisplayOption







// WEBPACK FOOTER //
// ./src/components/molecules/PaymentDisplayOption/PaymentDisplayOption.js